import { Component } from '@angular/core';

@Component({
    selector: 'jhi-heroimage',
    templateUrl: './heroimage.component.html',
    styleUrls: ['heroimage.scss'],
    standalone: false
})
export class HeroimageComponent {}
